import belfastCarChargingImage from '../../../assets/images/belfast/car-charging.jpg';
import belfastCityImage from '../../../assets/images/belfast/belfast-city.jpg';
import belfastStreetImage from '../../../assets/images/belfast/belfast-street.jpg';

/** @type {import('./cityLandingPageData').CityData} */
const belfast = {
    cityName: 'Belfast',
    searchQuery: 'Belfast',
    heroHeading: "Find EV Chargers in Belfast",
    heroSubheading: "Search for electric vehicle charging points across Belfast and Northern Ireland. From the Cathedral Quarter to the Titanic Quarter, EVBuddy helps you find your nearest charger and charge with confidence.",
    searchPlaceholder: "Try a Belfast postcode, e.g. BT1...",
    networkSection: {
        heading: "Belfast's Growing Charging Network",
        paragraphs: [
            "Belfast is rapidly expanding its electric vehicle charging infrastructure, with public charge points now spread across the city and into wider Northern Ireland.",
            <>By 2028 Belfast City Council plans to support at least <a href="https://ehq-production-europe.s3.eu-west-1.amazonaws.com/ee24984f61dd2993f04a86e0bfd1f3245d418be2/original/1711112882/95e072bf98b455d34cbc109b2a8a82e0_Our_Planet_Action_Plans_2024_2028.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA4KKNQAKIPIPQP5NM%2F20260510%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20260510T204345Z&X-Amz-Expires=300&X-Amz-SignedHeaders=host&X-Amz-Signature=f32acaa515c181204b737f40b8530ee09bbc105f08ec8be665bcf41d532ad4fc#page=5y" target="_blank" rel="noopener noreferrer">800 electric vehicle charging points</a> across the city.</>,
            "EVBuddy shows you their locations and latest status, giving you confidence in finding an available charger wherever you are in the city.",
        ],
        image: belfastCityImage,
        imageAlt: "Electric vehicle charging at a public charge point in Belfast city centre",
    },
    filterSection: {
        heading: "Find the Right Charger for Your Vehicle",
        paragraphs: [
            "Not all chargers are the same. Whether you need a rapid speed charger for a quick top-up in the City Centre or a slower overnight charger near your South Belfast home, EVBuddy allows you to filter by connector type and charging speed so you always find the right match.",
        ],
        image: belfastCarChargingImage,
        imageAlt: "EV charging in Belfast",
    },
    navigateSection: {
        heading: "Navigate Belfast with Confidence",
        paragraphs: [
            "Driving around Belfast shouldn't mean worrying about range anxiety. EVBuddy shows you chargers on an interactive map so you can plan your journey across the city.",
        ],
        image: belfastStreetImage,
        imageAlt: "Belfast street scene",
    },
    seo: {
        title: "EV Charging Points in Belfast | Find Chargers Near You | EVBuddy",
        description: "Find electric vehicle charging points across Belfast. Search for public EV chargers in Belfast City Centre, East Belfast, West Belfast, North Belfast, and across Northern Ireland with EVBuddy.",
        keywords: "EV charging Belfast, electric vehicle chargers Belfast, EV charging points Belfast, public EV chargers Belfast, Belfast electric car charging, charge my EV Belfast, rapid chargers Belfast, Northern Ireland EV chargers",
        canonicalUrl: "https://evbuddy.io/belfast",
        ogImage: "https://evbuddy.io/static/media/belfast-city.jpg",
        ogDescription: "Find electric vehicle charging points across Belfast and Northern Ireland. Search for public EV chargers with EVBuddy.",
    },
};

export default belfast;
